module.exports = __webpack_public_path__ + "img/ZM.c197a86a.png";